import { FeatureFlagsParsed } from '@/contexts/Flags/featureFlags.types';

type ChurnUsersConfig = FeatureFlagsParsed['USERS_TO_ACCESS_SCREEN_CHURN'];

const normalizeEmail = (email?: string | null): string =>
    (email ?? '').trim().toLowerCase();

const parseEmailList = (value: unknown): string[] => {
    if (Array.isArray(value)) {
        return value
            .filter((item): item is string => typeof item === 'string')
            .map(normalizeEmail)
            .filter(Boolean);
    }

    if (typeof value === 'string') {
        return value
            .split(/[\n,;]+/)
            .map(normalizeEmail)
            .filter(Boolean);
    }

    return [];
};

export const getAllowedChurnUsers = (
    churnConfig: ChurnUsersConfig,
    environment: string,
): Set<string> => {
    const isStaging = ['staging', 'development'].includes(environment);
    const envUsers = parseEmailList(
        isStaging ? churnConfig?.users_stg : churnConfig?.users_prod,
    );
    const fallbackUsers = [
        ...parseEmailList(churnConfig?.users_stg),
        ...parseEmailList(churnConfig?.users_prod),
    ];

    return new Set(envUsers.length > 0 ? envUsers : fallbackUsers);
};

export const hasChurnAccessByEmail = (
    churnConfig: ChurnUsersConfig,
    environment: string,
    email?: string | null,
): boolean => {
    const currentUserEmail = normalizeEmail(email);

    if (!currentUserEmail) {
        return false;
    }

    return getAllowedChurnUsers(churnConfig, environment).has(currentUserEmail);
};
